import type { Component } from './types';

import React from 'react';

import { Input as SgcmInput } from '@sgcmpteltd/uikit-react';

import { inputVariant } from './configs';

import { cn } from '@/lib/utils';
import { formatWithThousandSeparator, unformatNumber } from '@/utils/number';

export const CustomInput: Component = (props) => {
  const {
    className,
    inputType = 'text',
    isInvalid,
    maxLength,
    noBorder,
    onChange,
    value,
    ...restProps
  } = props;
  const onCustomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (['text', 'text-number'].includes(inputType)) {
      if (maxLength && e.target.value.length > maxLength) {
        return;
      } else if (
        inputType === 'text-number'
        && !/^[0-9\s]*$/.test(e.target.value)
      ) {
        // block invalid input
        return;
      }

      onChange?.(e);
      return;
    }

    const rawValue = unformatNumber(e.target.value);

    if ((maxLength && rawValue.length > maxLength) || rawValue.length > 15) {
      return;
    }

    if (
      (props.inputType === 'currency' || props.inputType === 'decimal')
      && props.allowDecimal
      && /^\d+(?:\.\d*)?$/.test(rawValue)
    ) {
      onChange?.({
        ...e,
        target: {
          ...e.target,
          // Need to trick typescript with assigning string type in order for typescript accept the value as a number
          value: rawValue !== '' ? (rawValue as unknown as string) : '',
        },
      });
    } else if (/^\d.*$/.test(rawValue)) {
      onChange?.({
        ...e,
        target: {
          ...e.target,
          // Need to trick typescript with assigning string type in order for typescript accept the value as a number
          value:
            rawValue !== ''
              ? (Number.parseFloat(rawValue) as unknown as string)
              : '',
        },
      });
    } else if (rawValue === '') {
      onChange?.({
        ...e,
        target: {
          ...e.target,
          value: rawValue,
        },
      });
    }
  };

  return (
    <SgcmInput
      className={cn(
        inputVariant({ isInvalid: props.isInvalid, noBorder }),
        className,
      )}
      {...restProps}
      isBorderless={noBorder}
      {...(['number'].includes(inputType ?? '') && {
        inputMode: 'numeric',
        // pattern: '[0-9]',
      })}
      {...(['currency'].includes(inputType ?? '') && {
        inputMode: 'numeric',
        // pattern: '[0-9.,]',
      })}
      onChange={onCustomChange}
      value={value}
      {...(inputType === 'currency' && {
        value: formatWithThousandSeparator(
          value !== undefined && value !== null ? `${value}` : '',
        ),
      })}
    />
  );
};
